const digest = '230aa5f5b043dcd9917f0f7be3f88ec5487d641807d325c41f12d8077c839bf2';
const css = `._link_1xknf_1 a{display:inline;min-height:0}._link_1xknf_1 a:after{content:"";inset:0;position:absolute}._badge_1xknf_11{left:.5rem;position:absolute;top:.5rem;z-index:1}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'link': '_link_1xknf_1', 'badge': '_badge_1xknf_11' };
export const link = '_link_1xknf_1';
export const badge = '_badge_1xknf_11';
export { css, digest };